import React from 'react';

const ClearRecurrent = ({ state }) => {
    return (
        <div className=' tc dt pa2 ma1 w-25 bg-dark-gray light-blue  f7 dim pointer noselect shadow-1 fw0' onClick={state} title='Clicking this will delete your saved recurrent types'>Clear recurrent types</div>
    )
}

export default ClearRecurrent;